import React, { lazy, Suspense } from "react";
import { Box } from "@mui/material";
import Navbar from "../widgets/navbar/navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../Components/Widgets/SubMenuDrawer";
import Footer from "../widgets/footer";
import RevealSection from "../widgets/common/reveal-section";
import { HeroPlaceholder } from "../widgets/common/home-section-skeleton";
import { useTheme } from "@mui/material/styles";

const BannerHeroSlide = lazy(
  () => import("../../default/widgets/sliders/banner-hero-slide"),
);

const ExploreMoreSection = lazy(
  () => import("../../default/widgets/sliders/explore-more-section"),
);

const RecentlyViewed = lazy(
  () => import("../../../Components/Widgets/RecentlyViewed"),
);

const AllCollections = lazy(
  () => import("../../default/widgets/sliders/all-collections"),
);

const ExportDefault = (props) => {
  const theme = useTheme();
  const gap = { xs: 6, md: 8 };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar bg_color="#fff" {...props} />
      <MenuDrawer {...props} />
      <SubMenuDrawer {...props} />
      <Suspense fallback={<HeroPlaceholder theme={theme} />}>
        <BannerHeroSlide
          {...{
            ...props,
            mb: gap,
            slide: {
              slug: "women-collections-2",
              imagesPath: "/marketing/main",
              smallSpacing: true,
              // title: "",
              // desc: "",
              // descMaxWidth: "640px",
              // buttons: [
              //   {
              //     name: "STACKABLE NECKLACES",
              //     url: "/women/type/necklace?curation=stacking",
              //   },
              //   {
              //     name: "STACKABLE RINGS",
              //     url: "/women/type/ring?curation=stacking",
              //   },
              // ],
            },
          }}
        />
      </Suspense>

      <RevealSection id="womenCollections" variant="slider">
        <ExploreMoreSection
          {...{
            ...props,
            mb: gap,
            title: "LATEST WOMEN'S COLLECTIONS",
            imagesPath: "/marketing/collections",
            buttons: [
              {
                name: "VIEW ALL",
                url: "/women/collectionS",
              },
            ],
            slides: [
              {
                slug: "theodora-collection",
                url: "/women/collection/theodora",
                buttons: [
                  {
                    name: "THEODORA COLLECTION",
                    url: "/women/collection/theodora",
                  },
                ],
                description:
                  "Step into the luminous elegance of Theodora, where Byzantine-inspired details and delicate gold forms create designs of quiet power and refined beauty.",
              },
              {
                slug: "neda-collection",
                url: "/women/collection/neda",
                buttons: [
                  {
                    name: "SHOP NEDA",
                    url: "/women/collection/neda",
                  },
                ],
                description:
                  "Discover Neda, where hammered surfaces, radiant stones, and Greek-inspired details create jewelry with texture, depth, and refined presence.",
              },
              {
                slug: "rhea-collection",
                url: "/women/collection/rhea",
                buttons: [
                  {
                    name: "SHOP RHEA",
                    url: "/women/collection/rhea",
                  },
                ],
                description:
                  "Rhea captures color in motion, with bold stones and sculptural silhouettes designed to reveal depth, strength, and elegance.",
              },
              {
                slug: "kyma-collection",
                url: "/women/collection/kyma",
                buttons: [
                  {
                    name: "SHOP KYMA",
                    url: "/women/collection/kyma",
                  },
                ],
                description:
                  "Discover designs meticulously crafted to capture the Aegean Sea’s waves with clean lines, smooth curves, and sculptural forms.",
              },
              {
                slug: "amazona-collection",
                url: "/women/collection/amazona",
                buttons: [
                  {
                    name: "AMAZONA COLLECTION",
                    url: "/women/collection/amazona",
                  },
                ],
                description:
                  "Discover the Amazona Collection, where classic influences are shaped into a distinctly modern statement.",
              },
            ],
          }}
        />
      </RevealSection>

      <RevealSection id="allCollections" variant="slider">
        <AllCollections
          {...{
            ...props,
            mb: gap,
            gender: "women",
          }}
        />
      </RevealSection>

      <RevealSection id="recentlyViewed" variant="products">
        <RecentlyViewed
          {...props}
          mb={gap}
          title="ITEMS YOU VIEWED"
          productDisplay={{
            showName: false,
            showCollection: false,
            showPrice: false,
            showGems: false,
            showCuration: true,
          }}
        />
      </RevealSection>

      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
